(function() {
    'use strict';

    // Get Tabulator locale code from WordPress locale
    function getTabulatorLocale() {
        if (typeof csvTableImporterFrontend === 'undefined' || !csvTableImporterFrontend.tabulatorLocale) {
            return 'en-us'; // Default to English
        }

        var locale = csvTableImporterFrontend.tabulatorLocale;

        // Check if we have translations for this locale
        if (typeof csvTableImporterFrontend !== 'undefined' &&
            csvTableImporterFrontend.tabulatorLangs &&
            csvTableImporterFrontend.tabulatorLangs[locale]) {
            return locale;
        }

        // Try to find a fallback (e.g., if locale is 'pl' but we have 'pl-pl')
        if (typeof csvTableImporterFrontend !== 'undefined' && csvTableImporterFrontend.tabulatorLangs) {
            // Try exact match first
            if (csvTableImporterFrontend.tabulatorLangs[locale]) {
                return locale;
            }
            // Try language code only (e.g., 'pl' instead of 'pl-pl')
            var langCode = locale.split('-')[0];
            for (var key in csvTableImporterFrontend.tabulatorLangs) {
                if (key.startsWith(langCode + '-')) {
                    return key;
                }
            }
        }

        return 'en-us'; // Default fallback
    }

    // Initialize Tabulator tables when DOM is ready
    function initTabulatorTables() {
        // Find all table containers
        var containers = document.querySelectorAll('.csv-table-container');

        containers.forEach(function(container) {
            var tableIdElement = container.querySelector('[id^="csv-table-"]');
            if (!tableIdElement) return;

            var tableElementId = tableIdElement.id;
            var ajaxUrl = tableIdElement.getAttribute('data-ajax-url');
            var tableOptionsData = container.getAttribute('data-table-options');

            if (!ajaxUrl) {
                console.error('AJAX URL not found for table:', tableElementId);
                return;
            }

            try {
                var tableOptions = tableOptionsData ? JSON.parse(tableOptionsData) : {};

                // Get buttons
                var exportBtn = container.querySelector('.csv-export-selected-btn');
                var printBtn = container.querySelector('.csv-print-btn');

                // Show loading indicator BEFORE fetching data
                var loadingText = (typeof csvTableImporterFrontend !== 'undefined' && csvTableImporterFrontend.strings && csvTableImporterFrontend.strings.loadingTableData)
                    ? csvTableImporterFrontend.strings.loadingTableData
                    : 'Loading table data...';
                tableIdElement.innerHTML = '<div class="csv-table-loading">' +
                    '<span class="csv-loading-spinner"></span>' +
                    '<span style="margin-left: 10px;">' + loadingText + '</span>' +
                    '</div>';

                // Load data via AJAX first, then initialize Tabulator
                fetch(ajaxUrl)
                    .then(function(response) {
                        return response.json();
                    })
                    .then(function(result) {
                        // Handle both old format (array) and new format (object with data and column_order)
                        var tableData = Array.isArray(result.data) ? result.data : (result.data.data || result.data);
                        // Get column order from AJAX response, fallback to tableOptions if available
                        var columnOrder = (result.data.column_order || tableOptions.column_order || null);

                        if (result.success && Array.isArray(tableData) && tableData.length > 0) {
                            // Generate columns using column order if available, otherwise fallback to Object.keys
                            var columns = generateColumns(tableData, tableOptions, columnOrder);

                            // Build Tabulator config with columns and data
                            var tabulatorConfig = {
                                data: tableData, // Set data directly in config
                                layout: 'fitColumns',
                                pagination: 'local',
                                paginationSize: 50, // Default number of rows per page (increased from 10)
                                paginationSizeSelector: [50, 100],
                                movableColumns: true,
                                resizableColumns: true,
                                tooltips: true,
                                selectableRows: true, // Enable row selection - allows multiple rows
                                printAsHtml: true, // Enable HTML table printing
                                printStyled: true, // Copy Tabulator styling to printed table
                                printRowRange: 'active', // Print all active rows (filtered/sorted)
                                initialSort: [],
                                columnDefaults: {
                                    tooltip: true,
                                },
                                columns: columns, // Set columns in config
                            };

                            // Set locale and langs if available
                            if (typeof csvTableImporterFrontend !== 'undefined') {
                                if (csvTableImporterFrontend.tabulatorLangs) {
                                    tabulatorConfig.langs = csvTableImporterFrontend.tabulatorLangs;
                                }
                                var localeCode = getTabulatorLocale();
                                tabulatorConfig.locale = localeCode;
                            }

                            // Apply table-specific options (highest priority)
                            if (tableOptions.hide_headers === true) {
                                tabulatorConfig.headerVisible = false;
                            }

                            // Apply movable rows option (disabled by default)
                            if (tableOptions.movable_rows === true) {
                                tabulatorConfig.movableRows = true;
                            }

                            // Apply frozen rows option
                            if (tableOptions.frozen_rows && parseInt(tableOptions.frozen_rows, 10) > 0) {
                                tabulatorConfig.frozenRows = parseInt(tableOptions.frozen_rows, 10);
                            }

                            // Initialize Tabulator with full config (columns + data)
                            var table = new Tabulator('#' + tableElementId, tabulatorConfig);

                            // Attach event handlers after table is initialized
                            attachTableHandlers(table, container, exportBtn, printBtn);

                            // Initialize sort module if enabled
                            if (tableOptions.enable_sort_module === true) {
                                initSortModule(table, container, tableData, columnOrder);
                            }
                        } else {
                            console.error('No data received from server');
                            var errorText = (typeof csvTableImporterFrontend !== 'undefined' && csvTableImporterFrontend.strings && csvTableImporterFrontend.strings.errorLoadingTableData)
                                ? csvTableImporterFrontend.strings.errorLoadingTableData
                                : 'Error loading table data';
                            tableIdElement.innerHTML = '<div style="padding: 20px; text-align: center; color: #d63638;">' + errorText + '</div>';
                        }
                    })
                    .catch(function(error) {
                        console.error('Error loading table data:', error);
                        var errorText = (typeof csvTableImporterFrontend !== 'undefined' && csvTableImporterFrontend.strings && csvTableImporterFrontend.strings.errorLoadingTableData)
                            ? csvTableImporterFrontend.strings.errorLoadingTableData
                            : 'Error loading table data';
                        tableIdElement.innerHTML = '<div style="padding: 20px; text-align: center; color: #d63638;">' + errorText + '</div>';
                    });

            } catch (error) {
                console.error('Error initializing Tabulator:', error);
            }
        });
    }

    /**
     * Attach event handlers to Tabulator table
     */
    function attachTableHandlers(table, container, exportBtn, printBtn) {

        // Handle row selection changes
        table.on('rowSelectionChanged', function(data, rows) {
            if (data.length > 0) {
                // Show export button with count
                if (exportBtn) {
                    var originalText = exportBtn.getAttribute('data-original-text') || exportBtn.textContent.trim();
                    // Store original text if not already stored
                    if (!exportBtn.getAttribute('data-original-text')) {
                        exportBtn.setAttribute('data-original-text', originalText);
                    }
                    // Update button text with count
                    var countText = data.length === 1 ? '1 wiersz' : data.length + ' wierszy';
                    exportBtn.textContent = originalText + ' (' + countText + ')';
                    exportBtn.style.display = 'inline-block';
                }
            } else {
                // Hide export button
                if (exportBtn) {
                    exportBtn.style.display = 'none';
                }
            }
        });

        // Handle export button click
        if (exportBtn) {
            exportBtn.addEventListener('click', function() {
                exportSelectedRowsToCSV(table, container);
            });
        }

        // Handle print button click
        if (printBtn) {
            printBtn.addEventListener('click', function() {
                // Get all columns and ensure they're visible
                var columns = table.getColumns();

                // Force all columns to be visible, especially empty header columns
                columns.forEach(function(column) {
                    var field = column.getField();
                    // Show column and ensure it's printable
                    column.show();

                    // For empty header columns, explicitly set print option
                    if (field === '' || field === null || field === undefined) {
                        try {
                            // Try to modify column to ensure it's printable
                            column.modify({
                                visible: true,
                                print: true
                            });
                        } catch(e) {
                            console.warn('Could not modify column for print:', e);
                        }
                    }
                });

                // Small delay to ensure column modifications are applied
                setTimeout(function() {
                    // Print table with all active rows, styled
                    table.print('active', true);
                }, 50);
            });
        }

        // Store table instance for later use
        container.tabulatorInstance = table;
    }

    /**
     * Initialize sort module above the table
     */
    function initSortModule(table, container, data, columnOrder) {
        var sortModule = container.querySelector('.csv-sort-module');
        if (!sortModule) return;

        var sortField = sortModule.querySelector('.csv-sort-field');
        var sortDirection = sortModule.querySelector('.csv-sort-direction');
        var sortTriggerBtn = sortModule.querySelector('.csv-sort-trigger-btn');
        var sortClearBtn = sortModule.querySelector('.csv-sort-clear-btn');

        if (!sortField || !sortDirection || !sortTriggerBtn || !sortClearBtn) return;

        // Show sort module
        sortModule.style.display = 'block';

        // Populate sort field select with column names in correct order
        if (data && data.length > 0) {
            var firstRow = data[0];
            // Use column order if provided, otherwise fallback to Object.keys
            var keys = columnOrder && Array.isArray(columnOrder) ? columnOrder : Object.keys(firstRow);

            keys.forEach(function(key) {
                // Skip if key doesn't exist in first row (safety check)
                if (!(key in firstRow)) {
                    return;
                }
                var option = document.createElement('option');
                option.value = key;
                option.textContent = key;
                sortField.appendChild(option);
            });
        }

        // Handle sort trigger button
        sortTriggerBtn.addEventListener('click', function() {
            var field = sortField.value;
            var direction = sortDirection.value;

            if (!field) {
                var alertText = (typeof csvTableImporterFrontend !== 'undefined' && csvTableImporterFrontend.strings && csvTableImporterFrontend.strings.pleaseSelectColumn)
                    ? csvTableImporterFrontend.strings.pleaseSelectColumn
                    : 'Please select a column to sort by.';
                console.error(alertText);
                return;
            }

            // Trigger sort using Tabulator's setSort function
            table.setSort(field, direction);
        });

        // Handle clear sort button
        sortClearBtn.addEventListener('click', function() {
            // Clear all sorting
            table.clearSort();
            // Reset select fields
            sortField.value = '';
            sortDirection.value = 'asc';
        });
    }

    // Generate columns from data
    function generateColumns(data, options, columnOrder) {
        if (!data || data.length === 0) {
            return [];
        }

        options = options || {};
        var columns = [];
        var firstRow = data[0];

        // Find all _col_* fields and _display_header_* fields
        var colFields = [];
        var maxIndex = -1;

        // Find maximum column index
        Object.keys(firstRow).forEach(function(key) {
            if (key.startsWith('_col_')) {
                var index = parseInt(key.replace('_col_', ''));
                if (!isNaN(index) && index > maxIndex) {
                    maxIndex = index;
                }
            }
        });

        // Generate columns using numeric indices (handles duplicate headers)
        for (var i = 0; i <= maxIndex; i++) {
            var field = '_col_' + i;
            var displayHeaderKey = '_display_header_' + i;

            // Check if this column exists in data
            if (!(field in firstRow)) {
                continue;
            }

            // Get display header from data (original header, may be duplicate)
            var displayHeader = firstRow[displayHeaderKey] || '';
            if (displayHeader === '') {
                displayHeader = ' '; // Use space for empty headers
            }

            var column = {
                title: displayHeader, // Show original header (may be duplicate)
                field: field, // Use unique field name (_col_0, _col_1, etc.)
                editor: false,
                sorter: 'string', // Default sorter, Tabulator will auto-detect based on data
                visible: true, // Ensure column is visible, including in print
                print: true, // Explicitly enable printing for this column
                // Add formatter to ensure empty values are displayed
                formatter: function(cell, formatterParams) {
                    var value = cell.getValue();
                    return value !== null && value !== undefined ? value : '';
                },
                // Print formatter to ensure column is included in print
                printFormatter: function(cell, formatterParams) {
                    var value = cell.getValue();
                    return value !== null && value !== undefined ? value : '';
                }
            };

            // First column gets minimum width to prevent text clipping on desktop
            if (i === 0) {
                column.minWidth = 310;
            }

            // Add headerFilter only if hide_search is not true
            if (!options.hide_search) {
                column.headerFilter = 'input';
            }

            // Disable header sorting by default, enable only if enable_column_sorting is true
            // Sort module also disables header sorting
            if (options.enable_column_sorting === true && options.enable_sort_module !== true) {
                column.headerSort = true;
            } else {
                column.headerSort = false;
            }

            columns.push(column);
        }

        return columns;
    }

    // Export selected rows to CSV
    function exportSelectedRowsToCSV(table, container) {
        var selectedData = table.getSelectedData();

        if (!selectedData || selectedData.length === 0) {
            var alertText = (typeof csvTableImporterFrontend !== 'undefined' && csvTableImporterFrontend.strings && csvTableImporterFrontend.strings.noRowsSelected)
                ? csvTableImporterFrontend.strings.noRowsSelected
                : 'No rows selected';
            console.warn(alertText);
            return;
        }

        // Get table ID for filename
        var tableId = container.getAttribute('data-table-id') || 'table';
        var filename = 'table-' + tableId + '-export.csv';

        // Get headers in correct order from table columns (preserves original sequence)
        // Use display headers (titles) instead of field names for export
        var columns = table.getColumns();
        var headers = [];
        columns.forEach(function(column) {
            var field = column.getField();
            // Skip only internal fields that should never be exported
            if (field !== null && field !== undefined &&
                field.startsWith('_col_') &&
                !field.startsWith('_original_header_') &&
                !field.startsWith('_display_header_') &&
                field !== '_row_index' &&
                field !== '_row_number') {
                // Use column title (display header) for export, not field name
                var title = column.getDefinition().title || '';
                if (selectedData.length > 0 && field in selectedData[0]) {
                    headers.push(title === ' ' ? '' : title); // Convert space back to empty string
                }
            }
        });

        console.log('Export headers:', headers);
        console.log('First row data keys:', Object.keys(selectedData[0]));

        // Fallback: if no columns found, use Object.keys (but this may change order)
        if (headers.length === 0) {
            console.warn('No columns found from table, using Object.keys (order may be incorrect)');
            headers = Object.keys(selectedData[0]).filter(function(key) {
                return !key.startsWith('_original_header_') && key !== '_row_index' && key !== '_row_number';
            });
        }

        // Convert to CSV format
        var csvContent = convertToCSV(headers, selectedData);

        // Download CSV
        downloadCSV(csvContent, filename);
    }

    // Convert data to CSV format
    function convertToCSV(headers, rows) {
        var csv = '';

        // Add headers
        csv += headers.map(function(header) {
            return escapeCSV(header);
        }).join(',') + '\n';

        // Add rows - need to map headers back to field names
        rows.forEach(function(row) {
            var rowData = headers.map(function(header) {
                // Find the field name (_col_X) that corresponds to this header
                // Check _display_header_X fields to find matching header
                var field = null;
                for (var i = 0; i < 1000; i++) { // Reasonable max columns
                    var displayHeaderKey = '_display_header_' + i;
                    if (row[displayHeaderKey] === header || (header === '' && row[displayHeaderKey] === ' ')) {
                        field = '_col_' + i;
                        break;
                    }
                }
                // Fallback: if header is empty, try _col_0
                if (!field && header === '') {
                    field = '_col_0';
                }
                return escapeCSV(field ? (row[field] || '') : '');
            });
            csv += rowData.join(',') + '\n';
        });

        return csv;
    }

    // Escape CSV values
    function escapeCSV(value) {
        if (value === null || value === undefined) {
            return '';
        }
        value = String(value);
        if (value.includes(',') || value.includes('"') || value.includes('\n')) {
            return '"' + value.replace(/"/g, '""') + '"';
        }
        return value;
    }

    // Download CSV file
    function downloadCSV(csvContent, filename) {
        var BOM = '\uFEFF'; // UTF-8 BOM for Excel compatibility
        var blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement('a');
        var url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            // Wait for Tabulator to be available
            if (typeof Tabulator !== 'undefined') {
                initTabulatorTables();
            } else {
                // Retry after a short delay
                setTimeout(function() {
                    if (typeof Tabulator !== 'undefined') {
                        initTabulatorTables();
                    } else {
                        console.error('Tabulator library not loaded');
                    }
                }, 100);
            }
        });
    } else {
        // DOM already loaded
        if (typeof Tabulator !== 'undefined') {
            initTabulatorTables();
        } else {
            // Wait for Tabulator
            setTimeout(function() {
                if (typeof Tabulator !== 'undefined') {
                    initTabulatorTables();
                } else {
                    console.error('Tabulator library not loaded');
                }
            }, 100);
        }
    }
})();
